module.exports = __webpack_public_path__ + "img/carol-galvao-juskit-lua-atualizado.08897d0d.webp";